import { render } from "./ManifestoPage.vue?vue&type=template&id=4bd7ea67&scoped=true"
import script from "./ManifestoPage.vue?vue&type=script&lang=js"
export * from "./ManifestoPage.vue?vue&type=script&lang=js"

import "./ManifestoPage.vue?vue&type=style&index=0&id=4bd7ea67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd7ea67"]])

export default __exports__